import React, { useEffect, useRef, useState } from "react";
import { FaAngleRight } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/pagination";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useOutletContext } from "react-router";

const Products = ({ categories, active, product }) => {
  const swiperRef = useRef();
  const { url } = useOutletContext();
  const navigate = useNavigate();

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const [progress, setProgress] = useState(0);
  const [total, setTotal] = useState(0);
  const [viewProducts, setViewProducts] = useState(6);

  useEffect(() => {
    if (swiperRef.current) {
      const swiper = swiperRef.current;

      setTotal(swiper.slides.length - swiper.loopedSlides * 2);

      swiper.on("progress", () => {
        setProgress(Math.round(swiper.progress * 100));
      });
    }
  }, []);

  useEffect(() => {
    setViewProducts(isMobile ? 4 : 6);
  }, [isMobile]);

  const chunk = (array, size) => {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
      array.slice(index * size, index * size + size),
    );
  };

  const groupedProducts = chunk(
    active !== 0 ? product.filter((item) => item.categoryId === active.categoryId) : product,
    viewProducts,
  );

  const moveToPage = (prdNo) => {
    navigate(`/shop/${url}/productsView/${prdNo}`);
  };

  return (
    <div className={`products`}>
      <Swiper
        onSlideChange={(swiper) =>
          setProgress(Math.round((swiper.realIndex / (swiper.snapGrid.length - 1)) * 100))
        }
        onProgress={(swiper) => setProgress(Math.round(swiper.progress * 100))}
        className="mySwiper"
        direction={"vertical"}
        modules={[Mousewheel]}
        mousewheel={{
          forceToAxis: true,
          sensitivity: 1,
        }}
        slidesPerView={1}
        loop={true}
        speed={500}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}>
        {groupedProducts.map((group, idx) => (
          <SwiperSlide key={idx}>
            <div className="content">
              {group.map((item, itemIdx) => (
                <div className="box" key={item.id ?? itemIdx} onClick={() => moveToPage(item.id)}>
                  <img
                    src={
                      item.media && item.media.length > 0
                        ? imgHandler(item.media)
                        : `/img/function_22_bg.png`
                    }
                    alt={item.name}
                  />
                  <div className="intro">
                    <span>{item.name}</span>
                    <button>
                      자세히보기 <FaAngleRight />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {active !== 0 && (
        <div className="progress">
          <span>1</span>
          <div className="bar">
            <p style={{ width: `${progress}%` }}></p>
          </div>
          <span>{groupedProducts.length}</span>
        </div>
      )}
    </div>
  );
};

export default Products;
